export const paginationTableMixin = {
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
    }
  },
  methods: {
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.handleSearch()
    },

    handleCurrentChange(current) {
      this.pagination.current = current
      this.fetchData()
    }
  }
}
